angular.module('impactx.dialog').service('ExtendedProductTooltipService', [
    '$mdPanel',
    'themeFactory',
    '$timeout',
    'dataGen',
    ExtendedProductTooltipService
]);

function ExtendedProductTooltipService($mdPanel, themeFactory, $timeout, dataGen) {
    
    var panelRef = null;
    var timer;
    var isOpen;

    function open(event, product, delay) {
        if (!panelRef) {
            timer = $timeout(function () {
                var tempScope = {};
                dataGen.getData(tempScope, {proId: product.id}, "/product/tooltip").then(function () {
                    var tooltipConfig = {
                        attachTo: angular.element(document.body),
                        controller: function () {
                            this.theme = themeFactory.getTheme();
                            this.data = tempScope.data;
                            this.trns = tempScope.trns;
                        },
                        controllerAs: '$ctrl',
                        position: $mdPanel.newPanelPosition().relativeTo(event.target)
                            .addPanelPosition(
                                $mdPanel.xPosition.CENTER,
                                $mdPanel.yPosition.BELOW
                            )
                            .addPanelPosition(
                                $mdPanel.xPosition.OFFSET_END,
                                $mdPanel.yPosition.CENTER),
                        event: event,
                        templateUrl: 'modules/product/templates/extended-product-tooltip.tmpl.html',
                        panelClass: 'extended-product-tooltip-panel',
                        propagateContainerEvents: true,
                        clickOutsideToClose: true,
                    };

                    panelRef = $mdPanel.create(tooltipConfig);

                    if (!isOpen) {
                        isOpen = true;
                        panelRef.open();
                    }

                });
            }, delay);
        }
    };

    function close() {
        $timeout.cancel(timer);
        if (panelRef) {
            panelRef.close().then(function () {
                panelRef.destroy();
                panelRef = null;
            });
        }
        isOpen = false;
    };

    function stopTimer()
    {
        if (timer) {
            $timeout.cancel(timer);
        }
    };

    return {
        open: open,
        close: close,
        stopTimer: stopTimer
    }
}